import Axios from "axios";
import { UserActions } from "./userActions";
import { accessTokenKey, baseUrl, getToken } from "./utilActions";
import moment from "moment";

function prefix(action) {
  return `APP_${action}`;
}
  
export const AppActions = {
  DEV_MODE: prefix('DEV_MODE'),
  ERROR: prefix('ERROR'),
  ERROR_ALERT: prefix('ERROR_ALERT'),
  LANG: prefix('LANG'),
  POPUP: prefix('POPUP'),
  RESET_ERR: prefix('RESET_ERR'),
  SHOW_PB: prefix('SHOW_PB'),
  HIDE_PB: prefix('HIDE_PB'),
  REG_FAIL: prefix('REG_FAIL'),
  INAGURATE: prefix('INAGURATE'),
  INAGURATE_USER: prefix('INAGURATE_USER'),
  JOURNAL_MENU: prefix('JOURNAL_MENU'),
};

export const DeveloperMode = mode => {
  return {
    type: AppActions.DEV_MODE,
    payload: mode
  };
};

export const ClearErrorMessages = () => dispatch => {
  dispatch({ type: AppActions.ERROR, payload: null });
  dispatch({ type: AppActions.ERROR_ALERT, payload: null });
  dispatch({ type: UserActions.QRCODE, payload: null });
};

export const OpenPopup = name => {
  return {
    type: AppActions.POPUP,
    payload: name
  };
};

export const ChangeLanguage = lang => dispatch => {
    dispatch({ type: AppActions.LANG, payload: lang });
};

// export const GetSiteInagurationStatus = () => dispatch => {
//   const db = getDatabase();
//   const starCountRef = ref(db, 'config');
//   onValue(starCountRef, (snapshot) => {
//     const data = snapshot.val();
//     // console.log('config', data);
//     dispatch({ type: AppActions.INAGURATE, payload : data });
//     if (!data["website-started"]){
//       const users = ref(db, 'users');
//       onValue(users, (snapshot) => {
//         const data = snapshot.val();
//         var list = [];
//         data && Object.keys(data).forEach((x,i)=>{
//           list.push({username: data[x].username, id: data[x].id});
//         });
//         list = list.sort(function(a, b) {
//           return a.id - b.id;
//         });
//         // console.log('users', data);
//         dispatch({ type: AppActions.INAGURATE_USER, payload : list });
//       });
//     }
//   });
// }

// export const AddNameToFirebase = (name) => dispatch => {
//   const db = getDatabase();
//   set(ref(db, 'users/u-' + (Math.floor(Math.random()*1000000000000000)) + name), {
//     username: name
//   });
// }

export const GetSweedhangamMenu = () => dispatch => {
  Axios.get(`${baseUrl}/api/sweedhangam/all`, { headers: { authorization: "Bearer " + getToken(accessTokenKey) } }).then(result => {
    var data = result.data.map( x => {
      let monthFull = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      let monthFullta = ["ஜனவரி", "பிப்ரவரி", "மார்ச்", "ஏப்ரல்", "மே", "ஜூன்", "ஜூலை", "ஆகஸ்ட்", "செப்டம்பர்", "அக்டோபர்", "நவம்பர்", "டிசம்பர்"];
      x.name = monthFull[ x.month -1 ] + " " + x.year;
      x.nametamil = monthFullta[ x.month -1 ] + " " + x.year;
      x.location = "/sweedhangam/" + x.year + "/" + x.month;
      x.dev = true;
      return x;
    })
    dispatch({ type: AppActions.JOURNAL_MENU, payload: data });
  }).catch(error => {
    dispatch({ type: AppActions.ERROR, payload: { response: error.response, request: error } });
  });
};
